export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SING_UP = 'AUTH_SING_UP';
export const AUTH_RESTORE = 'AUTH_RESTORE';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const CHANGE_USER_ATTRIBUTES = 'CHANGE_USER_ATTRIBUTES';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_SING_OUT = 'AUTH_SING_OUT';
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
